import React from "react";
import { Banner, Button, Flex, Text } from "@jsq/ds/core";
import { bannerContainer } from "./styles_vanilla.css";
import { PaymentFailedBannerProps } from "./types";
import { getPaymentFailedBannerTitle } from "./utils";

export const PaymentFailedBanner: React.FC<PaymentFailedBannerProps> = ({
  failedPaymentDetails,
  updateInstructionsUrl,
}) => {
  const title = getPaymentFailedBannerTitle(failedPaymentDetails);

  const handleUpdateInstructionsClick = () => {
    if (updateInstructionsUrl) {
      window.open(updateInstructionsUrl, "_blank");
    }
  };

  const description = (
    <Flex gap={12} flexDirection="column">
      <Text>
        There&apos;s an error with the payment instructions. Update payment instructions and
        then reissue the payment.
      </Text>
      {updateInstructionsUrl && (
        <Flex>
          <Button
            data-testid="update-instructions-button"
            variant="neutral"
            onClick={handleUpdateInstructionsClick}
          >
            Update payment instructions
          </Button>
        </Flex>
      )}
    </Flex>
  );

  return (
    <div className={bannerContainer}>
      <Banner variant="danger" title={title} isDescriptionJsx description={description} />
    </div>
  );
};

export default PaymentFailedBanner;
